import classNames from 'classnames';
import * as React from 'react';

import SVG from '../SVG/SVG';

import styles from './InlineIcon.module.css';

type InlineIconProps = {
    className?: string;
    style?: React.CSSProperties;
    src: string;
    size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
    color?:
        | 'currentColor'
        | 'subdued'
        | 'light'
        | 'white'
        | 'brand'
        | 'error'
        | 'warning'
        | 'success'
        | 'successLighter'
        | 'disabled';
};

const InlineIcon = ({
    className,
    size = 'medium',
    color = 'currentColor',
    ...svgProps
}: InlineIconProps) => (
    <SVG
        className={classNames(styles.Root, className, {
            [styles.sizeXSmall]: size === 'xsmall',
            [styles.sizeSmall]: size === 'small',
            [styles.sizeLarge]: size === 'large',
            [styles.sizeXLarge]: size === 'xlarge',
            [styles.sizeXXLarge]: size === 'xxlarge',
            [styles.colorCurrentColor]: color === 'currentColor',
            [styles.colorSubdued]: color === 'subdued',
            [styles.colorLight]: color === 'light',
            [styles.colorWhite]: color === 'white',
            [styles.colorBrand]: color === 'brand',
            [styles.colorError]: color === 'error',
            [styles.colorWarning]: color === 'warning',
            [styles.colorSuccess]: color === 'success',
            [styles.colorSuccessLighter]: color === 'successLighter',
            [styles.colorDisabled]: color === 'disabled',
        })}
        {...svgProps}
    />
);

export default InlineIcon;
